<div [class]="classString()">
  <ng-content></ng-content>
</div>
